import * as request from './utils/requester';

export const getAll = (page) => request.get(`/compliance?page=${page}`);

export const getById = (id) => request.get(`/compliance/${id}`);

export const create = (data) => request.post('/compliance', data);

export const edit = (data) => request.put(`/compliance/${data._id}`, data);

export const del = (data) => request.del(`/compliance/${data._id}`);


export const getOption = (option) => request.get(`/compliance?option=${option}`);